import Component from './Component'
import gsap from 'gsap'
import App from '@scripts/app'

export default class Cursor extends Component {
  constructor(el, initiator) {
    super(el, initiator)

    this.mouse = {
      x: 0, y: 0
    }

    this.init()
  }

  getElems() {
    this.label = this.el.querySelector('.cursor__label')
    this.circle = this.el.querySelector('.cursor__circle')
    this.arrows = this.el.querySelector('.cursor__arrows')
  }

  bindMethods() {
    super.bindMethods()

    this.onMouseEnter = this.toggleHover.bind(this, true)
    this.onMouseLeave = this.toggleHover.bind(this, false)
  }

  events() {
    super.events()

    if (this.elems) this.eventsReset()

    this.elems = document.body.querySelectorAll('a, button, .js-cursor-hover')

    if (this.elems) {
      this.elems.forEach((item) => {
        item.addEventListener('mouseenter', this.onMouseEnter)
        item.addEventListener('mouseleave', this.onMouseLeave)
      })
    }
  }

  eventsReset() {
    this.elems.forEach((item) => {
      item.removeEventListener('mouseenter', this.onMouseEnter)
      item.removeEventListener('mouseleave', this.onMouseLeave)
    })
  }

  init() {
    const ease = 'expo.out'

    this.setLabelX = gsap.quickTo(this.label, 'x', { duration: 0.5, ease })
    this.setLabelY = gsap.quickTo(this.label, 'y', { duration: 0.5, ease })
    this.setArrowX = gsap.quickTo(this.arrows, 'x', { duration: 0.7, ease })
    this.setArrowY = gsap.quickTo(this.arrows, 'y', { duration: 0.7, ease })
    this.setCircleX = gsap.quickTo(this.circle, 'x', { duration: 0.6, ease })
    this.setCircleY = gsap.quickTo(this.circle, 'y', { duration: 0.6, ease })
  }

  pointermove(e) {
    super.pointermove()

    if (!App.isDevice('laptop-min')) return

    this.mouse.x = e.clientX
    this.mouse.y = e.clientY

    this.setLabelX(this.mouse.x)
    this.setLabelY(this.mouse.y)
    this.setArrowX(this.mouse.x)
    this.setArrowY(this.mouse.y)
    this.setCircleX(this.mouse.x)
    this.setCircleY(this.mouse.y)
  }

  toggleHover(bool) {
    this.el.classList.toggle('app--hover', bool)
  }

  toggleScroll(bool) {
    this.el.classList.toggle('app--scroll', bool)
  }

  toggleMoving(bool) {
    this.el.classList.toggle('app--move', bool)
  }

  toggleDragging(bool) {
    this.el.classList.toggle('app--drag', bool)
  }

  togglePressed(bool) {
    this.el.classList.toggle('app--press', bool)
  }

  toggleClose(bool) {
    this.el.classList.toggle('app--close', bool)
  }

  toggleHide(bool) {
    this.el.classList.toggle('app--hide', bool)
  }
}
